<template>
  <div class="modal modal-sla-form fade fixed-end" tabindex="-1" role="dialog">
    <div
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">{{ title }}</h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">

          <div class="mb-3" v-if="create">
            <label class="control-label">Type</label>
            <multiselect
              :show-labels="false"
              v-model="editSLA.type"
              :options="items"
              label="name"
              track-by="id"
              @select="typeChanged"
              v-validate="'required'"
              data-vv-name="type"
            ></multiselect>
            <help-block field="type" />
          </div>

          <div class="mb-3" v-if="create">
            <label class="control-label">Client</label>
            <multiselect
              :show-labels="false"
              v-model="editSLA.client"
              :options="clients"
              label="company"
              track-by="id"
              v-validate="'required'"
              data-vv-name="client"
            ></multiselect>
            <help-block field="client" />
          </div>

          <div class="mb-3" v-if="create">
            <label class="control-label">Start Date</label>
            <datepicker
              name="start_date"
              v-model="editSLA.start_date"
              input-class="form-control"
              data-vv-as="start date"
              :clear-button="true"
            ></datepicker>
            <small class="form-text text-muted"
              >Leave blank to start on acceptance of quote.</small
            >
            <help-block field="start_date" />
          </div>

          <div class="mb-3">
            <label class="control-label">Monthly Hours</label>
            <div class="input-group">
              <input
                name="monthly_hours"
                v-model="editSLA.monthly_hours"
                type="text"
                class="form-control"
                data-vv-validate-on="input|blur"
                data-vv-as="monthly hours"
              />
              <span class="input-group-text">hrs</span>
            </div>
            <help-block field="monthly_hours" />
          </div>

          <div class="mb-3">
            <label class="control-label">Override Rate</label>
            <div class="input-group">
              <span class="input-group-text">$</span>
              <input
                name="override_rate"
                v-model="editSLA.override_rate"
                type="text"
                class="form-control"
                data-vv-validate-on="input|blur"
                data-vv-as="override rate"
              />
              <span class="input-group-text">per hour</span>
            </div>
            <help-block field="override_rate" />
          </div>

          <div class="mb-3">
            <div class="form-check">
              <input
                v-model="editSLA.annual_billing"
                type="checkbox"
                class="form-check-input"
                id="annual_billing"
              />
              <label class="form-check-label" for="annual_billing"
                >Annual billing (invoiced once per year)</label
              >
            </div>
          </div>

          <div class="mb-3" v-if="editSLA.annual_billing">
            <label class="control-label">Annual Billing Date</label>
            <datepicker
              name="annual_billing_date"
              v-model="editSLA.annual_billing_date"
              input-class="form-control"
              data-vv-as="annual billing date"
              :clear-button="true"
            ></datepicker>
            <small class="form-text text-muted"
              >The date each year's invoice is raised. Used to forecast the annual
              invoice.</small
            >
            <help-block field="annual_billing_date" />
          </div>

          <template v-if="create">
            <div class="form-check mb-2">
              <input
                v-model="editSLA.send_panda_quote"
                type="checkbox"
                class="form-check-input"
                id="send_panda_quote"
              />
              <label class="form-check-label" for="send_panda_quote"
                >Generate and send panda quote?</label
              >
            </div>

            <div class="mb-3" v-if="editSLA.send_panda_quote">
              <label class="control-label">Send From</label>
              <multiselect
                :show-labels="false"
                v-model="editSLA.user"
                :options="users"
                label="name"
                track-by="id"
                placeholder="Send from"
                v-validate="'required'"
                data-vv-name="user"
              ></multiselect>
              <help-block field="user" />
            </div>

            <div class="mb-3" v-if="editSLA.send_panda_quote && editSLA.client">
              <label class="control-label">Send To</label>
              <multiselect
                :show-labels="false"
                v-model="editSLA.contact"
                :options="contacts"
                label="name"
                track-by="id"
                placeholder="Send to"
                v-validate="'required'"
                data-vv-name="contact"
              >
                <template slot="singleLabel" slot-scope="props"
                  ><span class="option__title">{{ props.option.name }}</span
                  ><span class="option__small">{{
                    props.option.email
                  }}</span></template
                >
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{ props.option.name }}</span
                    ><span class="option__small">{{ props.option.email }}</span>
                  </div>
                </template>
              </multiselect>
              <help-block field="contact" />
            </div>
          </template>
        </div>
        <!-- /.modal-body -->

        <div class="modal-footer">
          <button
            v-if="!create"
            type="button"
            class="btn btn-danger me-auto"
            data-bs-toggle="modal"
            data-bs-target=".modal-sla-complete"
          >
            <i class="fal fa-times"></i>&nbsp;Complete SLA
          </button>
          <button type="button" class="btn btn-default" data-bs-dismiss="modal">
            Cancel
          </button>
          <ladda-button :on-click="handleSaveSla" class="btn btn-primary"
            >Save</ladda-button
          >
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<style>
.form-control {
  box-shadow: none !important;
}

.form-control[readonly] {
  background-color: transparent !important;
}
</style>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { http } from "utils";
import { Selectize, LaddaButton } from "components/form/input";
import Datepicker from "vuejs-datepicker";
import { notify } from "utils";
import { unset, cloneDeep } from "lodash";
import moment from "moment";
import Multiselect from "vue-multiselect";
import { CModal } from "@chameleon/chameleon-vue";

export default {
  $_veeValidate: {
    validator: "new", // give me my own validator scope.
  },
  props: ["title", "sla", "mode", "contactId"],
  extends: CModal,
  components: {
    Selectize,
    LaddaButton,
    Datepicker,
    Multiselect,
  },

  data() {
    return {
      editSLA: {},
    };
  },

  mounted() {
    this.getItems();
    this.getClients();
    this.getUsers();

    this.addEventListener("open", () => {
      this.editSLA = cloneDeep(this.sla);

      if (this.editSLA.client) this.getContacts(this.editSLA.client.id);
    });
  },

  computed: {
    ...mapState("users", ["users"]),
    ...mapState("clientsList", ["clients"]),
    ...mapState("contacts", ["contacts"]),
    ...mapState("slaTypes", ["items"]),
    ...mapGetters("contacts", ["getById"]),

    create: function () {
      return this.mode == "create";
    },
  },

  watch: {
    "editSLA.client": function (newItem) {
      //Ensure no contact is selected from a previous client selection
      this.editSLA.contact = null;

      if (this.editSLA.client) this.getContacts(this.editSLA.client.id);
    },
    contactId: function (id) {
      this.updateContact(id);
    },
  },

  methods: {
    ...mapActions("sla", ["addSLA", "updateSLA"]),
    ...mapActions("clientsList", ["getClients"]),
    ...mapActions("users", ["getUsers"]),
    ...mapActions("contacts", ["getContacts"]),
    ...mapActions("slaTypes", ["getItems"]),

    typeChanged(selected) {
      this.editSLA.monthly_hours = selected.base_hours;
    },

    handleSaveSla() {
      if (this.editSLA.id > 0) {
        return this.handleUpdateSla();
      } else {
        return this.handleAddSla();
      }
    },

    updateContact(contactId) {
      this.getContacts(this.editSLA.client.id).then(() => {
        this.editSLA.contact = this.getById(contactId);
      });
    },

    async handleAddSla() {
      if (!(await this._validate())) {
        notify.error(
          "Form validation failed, please check your inputs and try again."
        );
        return Promise.reject();
      }

      let payload = {
        client_id: this.editSLA.client.id,
        type_id: this.editSLA.type.id,
        send_panda_quote: this.editSLA.send_panda_quote,
        start_date: this.editSLA.start_date
          ? moment(this.editSLA.start_date).format("YYYY-MM-DD")
          : null,
        monthly_hours: this.editSLA.monthly_hours,
        override_rate: this.editSLA.override_rate,
        annual_billing: this.editSLA.annual_billing || false,
        annual_billing_date: this.editSLA.annual_billing_date
          ? moment(this.editSLA.annual_billing_date).format("YYYY-MM-DD")
          : null,
      };

      if (this.editSLA.send_panda_quote) {
        payload.contact_id = this.editSLA.contact.id;
        payload.user_id = this.editSLA.user.id;
      }

      return this.addSLA(payload)
        .then(() => {
          notify.success("SLA successfuly created.");
          this.close();
          this.$emit("created");
        })
        .catch((error) => {
          if (error.response.status === 422) {
            notify.error(
              "Form validation failed, please check your inputs and try again."
            );
          } else {
            notify.error("Failed to update sla details, please try again.");
          }
        });
    },

    async handleUpdateSla() {
      if (!(await this._validate())) {
        notify.error(
          "Form validation failed, please check your inputs and try again."
        );
        return Promise.reject();
      }

      let payload = {
        id: this.editSLA.id,
        payload: {
          contact_email: this.editSLA.contact_email,
          contact_firstname: this.editSLA.contact_firstname,
          contact_surname: this.editSLA.contact_surname,
          client_id: this.editSLA.client.id,
          type_id: this.editSLA.type_id,
          start_date: moment(this.editSLA.start_date).format("YYYY-MM-DD"),
          end_date: moment(this.editSLA.end_date).format("YYYY-MM-DD"),
          monthly_hours: this.editSLA.monthly_hours,
          override_rate: this.editSLA.override_rate,
          annual_billing: this.editSLA.annual_billing || false,
          annual_billing_date: this.editSLA.annual_billing_date
            ? moment(this.editSLA.annual_billing_date).format("YYYY-MM-DD")
            : null,
        },
      };

      return this.updateSLA(payload)
        .then(() => {
          notify.success("SLA successfuly updated.");
          this.close();
          this.$emit("updated");
        })
        .catch((error) => {
          if (error.response.status === 422) {
            notify.error(
              "Form validation failed, please check your inputs and try again."
            );
          } else {
            notify.error("Failed to update sla details, please try again.");
          }
        });
    },
  },
};
</script>
